// @ts-strict-ignore
import { LMFormatterService } from './lm-formatter.service';
import { LMFormatUtilService } from '@services/utils/lm-format-util.service';

export const lmRatingFormatter  = (
  lmFormatterService: LMFormatterService,
  lmFormatUtilService: LMFormatUtilService,
  row: number,
  cell: number,
  value: any,
  columnDef: ListGridColumn,
  dataView: LMListDataView,
  dataGrid: SohoDataGridStatic
): string  => {
  if (dataView.isTreeMoreLink) {
    return lmFormatterService.getMoreLink(cell, dataView);
  }

  if (columnDef.displayField.visibility) {
    if (!lmFormatterService.isConditionValid(columnDef.displayField.visibility, dataView)) {
      return '';
    }
  }

  if (lmFormatterService.isTotalRow(dataView)) {
    return lmFormatterService.formatTotalRowColumn(row, cell, value, columnDef, dataView, dataGrid);
  }

  const fieldId = columnDef.displayField.fieldId;
  const dataViewValue = dataView.fields[ fieldId ].value as number;

  const ratingOptions = lmFormatUtilService.formatStarRatingOptions(dataViewValue, columnDef.id);

  return `
      <div class="rating is-readonly" style="height: 25px;width:225px;">
      ${ratingOptions.map((option: LMStarRatingOption) => `<input
            type="radio"
            class="${option.class}"
            name="rating_option"
            id="${option.id}"
            value="${dataViewValue}">
              <label for="${option.id}">
                <svg class="icon" focusable="false" aria-hidden="true" role="presentation">
                  <use xlink:href="${option.href}"></use>
                </svg>
                <span class="audible">${option.label}</span>
              </label>
          </input>`).join('')}
      </div>
    `;
};
